// src/composables/useHelpMode.ts
import { computed } from 'vue'
import { useAuthStore } from 'stores/auth-store'

export function useHelpMode() {
  const authStore = useAuthStore()

  const helpModeEnabled = computed(
    () => authStore.currentUser?.settings?.helpModeEnabled === true,
  )

  const toggleHelpMode = async () => {
    await authStore.updateSettings({
      helpModeEnabled: !helpModeEnabled.value,
    })
  }

  return { helpModeEnabled, toggleHelpMode }
}
